import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import { Box, Container, Skeleton } from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import YouTube from 'react-youtube';
import { useDevice } from '../../../hooks/useResponsive';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

export default function InspectionYoutube({ youtubeId }) {
  const { isMobile } = useDevice();
  const [isLoading, setIsLoading] = useState(true);

  // console.log(youtubeId)
  const opts = {
    width: isMobile ? '310px' : '580px',
    height: isMobile ? '300px' : '320px',
    host: 'https://www.youtube-nocookie.com',
    playerVars: {
      autoplay: 0,
      rel: 0, // Hide related videos from other channels (may still show same-channel)
      modestbranding: 1, // Reduce YouTube branding
      controls: 0, // Hide all player controls/icons
      fs: 0, // Hide fullscreen button
      iv_load_policy: 3, // Hide video annotations
      cc_load_policy: 0, // Disable closed captions by default
      disablekb: 1, // Disable keyboard controls
      playsinline: 1, // Play inline on iOS
    },
  };
  // console.log(isLoading);
  return (
    <div>
      <StyledRoot sx={{ marginBottom: 0 }}>
        <Container
          className=""
          maxWidth="lg"
          sx={{
            paddingTop: { xs: '0', sm: '45px', md: 0 },
            // paddingBottom: { xs: '0', sm: '125px' },
            paddingLeft: { xs: '0', sm: '16px' },
            paddingRight: { xs: '0', sm: '16px' },
          }}
        >
          {/* <Grid container direction="row" className="bg-color"> */}

          <Box
            className="react-player inspection-web-video-box"
            sx={{ position: 'relative', width: isMobile ? 'auto' : 580, height: isMobile ? 'auto' : 320 }}
          >
            {/* YouTube player */}
            <YouTube
              videoId={youtubeId}
              opts={opts}
              className={`${isMobile ? 'react-player-video' : 'inspection-web-video'}`}
              iframeClassName={isMobile && 'w-100'}
              onReady={() => setIsLoading(false)}
              style={{ width: '100%', height: '100%' }}
            />

            {/* Skeleton overlay, only while loading */}
            {isLoading && (
              <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: isMobile ? '98%' : '90%',
                  borderRadius: 3,
                  zIndex: 1,
                }}
              />
            )}
          </Box>

          {/* </Grid> */}
        </Container>
      </StyledRoot>
    </div>
  );
}
InspectionYoutube.propTypes = {
  youtubeId: PropTypes.any,
};
